import { render, staticRenderFns } from "./Order1.vue?vue&type=template&id=e06893c6&scoped=true&"
import script from "./Order1.vue?vue&type=script&lang=js&"
export * from "./Order1.vue?vue&type=script&lang=js&"
import style0 from "./Order1.vue?vue&type=style&index=0&id=e06893c6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e06893c6",
  null
  
)

export default component.exports